import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Http, JsonpModule, Response } from '@angular/http';
import { User } from './user';
import * as _ from 'lodash';

import * as firebase from 'firebase/app';

@Injectable()
export class AuthService {
  users: FirebaseListObservable<any[]>;
  auth: string;
  emailSubject: Subject<any>;

  user: BehaviorSubject<User> = new BehaviorSubject(null);
  //userRoles: Array<string>;

  constructor(
    public af: AngularFireAuth,
    private db: AngularFireDatabase,
    private http: Http
  ) {
    this.af.authState
        .switchMap(auth => {
          if (auth) {
            /// signed in
            return this.db.object('users/' + auth.uid)
          } else {
            /// not signed in
            return Observable.of(null)
          }
        })
        .subscribe(user => {
          this.user.next(user);

        //  this.userRoles = _.keys(_.get(user, 'roles'));

        })




    this.emailSubject = new Subject();
    this.users = db.list('/users', {
      query: {
        orderByChild: 'email',
        equalTo: this.emailSubject
      }
    });
  }



  loginWithGoogle() {
    return this.af.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }
  logout() {
    return this.af.auth.signOut();
  }
  userId() {
    return this.af.auth.currentUser.uid;
  }

  checkIfUserExists(email) {
    this.http.get(`/checkIfUserAccountExists?email=${email}`)
      .map( (res: Response) => res.json())
      .subscribe(
        data => {
          if ( data === true) {
            return true;
          }else {
            return false;
          }
        },
        e => console.error(e)
      );
  }
  // return true;
//    this.emailSubject.next(email);
//    return this.users.subscribe( (snapshot) => {
//      if (snapshot !== null && snapshot.length !== 0) {
//        console.log('User does exist');
//        console.log(this.users);
//        return true;
//      } else {
//        console.log('User does not exist');
//        console.log(this.users);
//        return false;
//      }
//  });


  registerUser(data) {
      return this.af.auth.createUserWithEmailAndPassword(
        data.email.value,
        data.password.value
      ).then(
        (user) => {
          user.sendEmailVerification();
          return user;
      }).catch(
        (err) => {
        console.log(err);
        return err;
      });
  }

  private registerNewUser(data) {
    return this.af.auth.createUserWithEmailAndPassword(
      data.email.value,
      data.password.value
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/auth.service.ts